import Tooltip from "@mui/material/Tooltip"
import { ReactElement } from "react"

export type OptionalTooltipProps = {
  title?: string | null | undefined | false
  children: ReactElement
}

export default function OptionalTooltip({ title, children }: OptionalTooltipProps) {
  if(title) {
    return (
      <Tooltip title={title}>
        {children}
      </Tooltip>
    )
  }
  else {
    return children
  }
}
